export const DEV = "http://thebingetown.com:3003";
export const STAGE = "http://thebingetown.com:3003";
export const PROD = "https://thebingetown.com:3001";
export const VERSION = "newWeb9";
